"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var d3 = _interopRequireWildcard(require("d3"));
var _useChartDimensions = require("../hooks/useChartDimensions");
var _useChartTooltip = require("../hooks/useChartTooltip");
var _chartOperations = require("../utils/chart-operations");
var _SvgChart = _interopRequireDefault(require("../components/SvgChart"));
var _labelFormatter = require("../utils/label-formatter");
var _DonutChart = require("./DonutChart.styled");
var _useFilter = require("../hooks/useFilter");
var _useChartData = require("../hooks/useChartData");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BASE_MARGIN = Object.freeze({
  top: 0,
  bottom: 40,
  left: 10,
  right: 10
});
const ANIMATION_DURATION = 400;
const ANIMATION_ARC_DELAY = 150;
const DonutChart = /*#__PURE__*/(0, _react.memo)(chartProps => {
  var _chart$colors;
  const {
    chart,
    chartColors,
    animate
  } = chartProps;
  const {
    xCol,
    yCol,
    yFormat,
    seriesCol
  } = chart;
  const palette = ((_chart$colors = chart.colors) === null || _chart$colors === void 0 ? void 0 : _chart$colors.schemes.categorical) || chartColors.schemes.categorical;
  const {
    filter,
    filterComponent
  } = (0, _useFilter.useFilter)(chartProps);
  const [animationDone, setAnimationDone] = (0, _react.useState)(!animate);
  const svgRef = _react.default.useRef(null);
  const {
    width,
    height,
    margin
  } = (0, _useChartDimensions.useChartDimensions)(svgRef, BASE_MARGIN, chart.spanRow);
  // TODO: Check why this chart wasn't using chart data?
  let {
    data
  } = (0, _useChartData.useChartData)(chart, filter);
  const {
    tooltipRef,
    showTooltip,
    hideTooltip
  } = (0, _useChartTooltip.useChartTooltip)(chart, data, "xCol");
  const categories = chart.dataView.columns[seriesCol].categories;
  const radius = Math.min(width, height) / 2;
  const seriesLabels = _chartOperations.ChartOps.getSeriesLabels(chart, false);
  const seriesKeys = seriesLabels.map(series => series.key);
  const colorPalette = d3.scaleOrdinal().domain(seriesLabels.map(s => s.key)).range(palette);
  const pieGenerator = d3.pie().value(d => Number(d[yCol]));
  const arcGenerator = d3.arc().innerRadius(radius * 0.35).outerRadius(radius);
  const points = data.filter(d => {
    var _categories$d$seriesK;
    return !(categories !== null && categories !== void 0 && (_categories$d$seriesK = categories[d.seriesKey]) !== null && _categories$d$seriesK !== void 0 && _categories$d$seriesK.aggregate);
  }).map(d => d.points.at(-1)).filter(Boolean);
  const arcData = pieGenerator(points);
  const handleVisible = (0, _react.useCallback)(() => {
    if (animationDone) {
      return;
    }
    const arcs = svgRef.current.querySelectorAll(".arc");
    arcs.forEach(arc => arc.classList.add("full"));
    window.setTimeout(() => setAnimationDone(true), ANIMATION_DURATION + arcs.length * ANIMATION_ARC_DELAY);
  }, [animationDone]);
  function handleMouseEnter(e) {
    let el = e.target;
    if (el.tagName === "text") {
      const prev = el.previousElementSibling;
      if (prev) {
        el = prev;
      }
    }
    showTooltip(el, "auto");
    svgRef.current.querySelectorAll("path:not([data-series=\"".concat(el.dataset.series, "\"])")).forEach(path => {
      path.classList.add("semitransparent");
      //path.classList.remove("active");
    });

    svgRef.current.querySelectorAll("path[data-series=\"".concat(el.dataset.series, "\"]")).forEach(path => {
      path.classList.remove("semitransparent");
      path.classList.add("active");
    });
  }
  function handleMouseLeave(e) {
    hideTooltip();
    svgRef.current.querySelectorAll("path").forEach(rect => rect.classList.remove("semitransparent"));
  }
  return /*#__PURE__*/_react.default.createElement(_SvgChart.default, {
    margin: margin,
    svgRef: svgRef,
    chart: chart,
    tooltipRef: tooltipRef,
    palette: palette,
    keepAggregate: false,
    onVisible: handleVisible,
    filterComponent: filterComponent
  }, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("pattern", {
    id: "dashes",
    height: "10",
    width: "10",
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("line", {
    x1: "0",
    y1: "4",
    x2: "5",
    y2: "4",
    strokeWidth: "2",
    stroke: "#dddddd"
  }))), /*#__PURE__*/_react.default.createElement(_DonutChart.DonutGroup, {
    className: "donut-chart",
    transform: "translate(".concat(width / 2, ",").concat(height / 2, ")")
  }, arcData.map(d => /*#__PURE__*/_react.default.createElement("g", {
    key: d.index
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: "arc ".concat(!animationDone ? "" : "full"),
    d: arcGenerator(d),
    fill: seriesKeys.includes(d.data[seriesCol]) ? colorPalette(d.data[seriesCol]) : "url(#dashes)",
    stroke: "white",
    strokeWidth: "3px",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-x": d.data[xCol],
    "data-series": d.data[seriesCol],
    "data-color": colorPalette(d.data[seriesCol])
    // @ts-ignore
    ,
    style: {
      "--transition-delay": "".concat(ANIMATION_ARC_DELAY * d.index, "ms")
    }
  }), /*#__PURE__*/_react.default.createElement("text", {
    className: "inside-label",
    transform: "translate(".concat(arcGenerator.centroid(d), ")"),
    textAnchor: "middle",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    "data-x": d.data[xCol],
    "data-series": d.data[seriesCol],
    "data-color": colorPalette(d.data[seriesCol])
  }, d.endAngle - d.startAngle > 0.35 ? _labelFormatter.QuantitativeFormatter[yFormat](d.data[yCol]) : "")))));
});
var _default = DonutChart;
exports.default = _default;